/**
 * @generated SignedSource<<ec6b86fa7526dc732175fa80e3b532ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type collectionAboutSectionRelayFragment$data = {
  readonly aboutThisCollection: string | null | undefined;
  readonly aboutThisCollectionHeader: string | null | undefined;
  readonly aboutThisCollectionImage: {
    readonly name: string | null | undefined;
    readonly url: string;
  } | null | undefined;
  readonly name: string | null | undefined;
  readonly " $fragmentType": "collectionAboutSectionRelayFragment";
};
export type collectionAboutSectionRelayFragment$key = {
  readonly " $data"?: collectionAboutSectionRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"collectionAboutSectionRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "collectionAboutSectionRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "aboutThisCollectionHeader",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "aboutThisCollection",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTemplateImageAsset",
      "kind": "LinkedField",
      "name": "aboutThisCollectionImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": "name",
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplateCollection",
  "abstractKey": null
};

(node as any).hash = "da9e6616476bf8bc1a7a4460662418fe";

export default node;
